export const BASE_APP_PATH = "/";

export const route = (routePath?: string) => `${BASE_APP_PATH}${routePath}`;

export const routePaths = {
  base: route(""),
  login: route("login"),
  procedures: route("procedures"),
  /**
   * Where every "go to the procedures list" affordance points: the logo, the
   * `Trámites` menu item, the post-login landing, and the bounces after
   * save/delete/not-found. The default list is a view, not the unfiltered list.
   *
   * `procedures` above is deliberately NOT redirected here — it stays a real,
   * reachable state: the no-view list the global sidebar search lands on (a
   * global search and a view are mutually exclusive), and the fallback for an
   * unknown view slug.
   *
   * The `active` slug mirrors the server-owned registry
   * (`apps/api/apps/portus-api/src/controller/procedure-views/procedure-view-registry.ts`).
   * A rename there turns this into an unknown slug, which `ProceduresScreen`
   * already bounces to the plain list — degraded, not broken.
   */
  proceduresLanding: route("procedures/views/active"),
  procedureDetailDrawer: route("procedures/:procedureId"),
  procedureEdit: route("procedures/:procedureId/edit"),
  // A bare `/procedures/views` would otherwise match `procedures/:procedureId`
  // and open the drawer for a procedure literally called "views".
  procedureViewsIndex: route("procedures/views"),
  procedureViews: route("procedures/views/:viewSlug"),
  procedureViewDrawer: route("procedures/views/:viewSlug/:procedureId"),
  newProcedure: route("new-procedure"),
  reports: route("reports"),
  report: route("reports/:id"),
  signatures: route("signatures"),
  newSignature: route("signatures/new"),
  editSignature: route("signatures/:id/edit"),
  logout: route("logout"),
};
